import React, { ReactNode } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { actions } from "rdx";
import { CopyToClipboardCircle } from "components/Icons";
import copy from "copy-to-clipboard";

type TCopyToClipBoard = {
  valueToCopy: string | null;
  children?: ReactNode;
};

const CopyToClipBoard = ({ valueToCopy, children }: TCopyToClipBoard) => {
  const dispatch = useDispatch();

  const handleCopyAction = (value: string) => {
    copy(value);
    dispatch(
      actions.setAlertMessageVisible({
        message: (
          <span>
            <strong>{value}</strong> copied to the clipboard!
          </span>
        ),
        severity: "success",
      }),
    );
  };

  return (
    <>
      {valueToCopy && (
        <CopyTextRow
          role="none"
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleCopyAction(valueToCopy);
          }}
        >
          {children}
          <CopyToClipboardCircle />
        </CopyTextRow>
      )}
    </>
  );
};

export default CopyToClipBoard;

const CopyTextRow = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
}));
